import { HTTP } from "./http";
let API_SERVER = "";
if (process.env.NODE_ENV === "development") {
  API_SERVER =
    "http://www.localhost:8888/back-end-endpoint-external-leagues.php";
} else {
  API_SERVER = "/personal-training-BE/back-end-endpoint-external-leagues.php";
}

function post(action, data = {}) {
  return HTTP.post(API_SERVER, { action, ...data });
}

const ExternalLeagues = {
  getLeagues(clubId) {
    return post("getLeagues", { clubId });
  },

  getLadder(clubId, leagueId) {
    return post("getLadder", { clubId, leagueId });
  },

  getFixtures(clubId, leagueId) {
    return post("getFixtures", { clubId, leagueId });
  },

  getInternalTeams(clubId) {
    return post("getInternalTeams", { clubId });
  },

  mapTeam(clubId, teamId, leagueId, externalTeamId) {
    return post("mapTeam", { clubId, teamId, leagueId, externalTeamId });
  },

  unmapTeam(clubId, teamId) {
    return post("unmapTeam", { clubId, teamId });
  },

  getTeamSummary(clubId, teamId) {
    return post("getTeamSummary", { clubId, teamId });
  },
};

export { ExternalLeagues };
